import { render, staticRenderFns } from "./MmBasicInfoDialog.vue?vue&type=template&id=01b6bfd4&scoped=true&"
import script from "./MmBasicInfoDialog.vue?vue&type=script&lang=js&"
export * from "./MmBasicInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./MmBasicInfoDialog.vue?vue&type=style&index=0&lang=less&"
import style1 from "./MmBasicInfoDialog.vue?vue&type=style&index=1&id=01b6bfd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b6bfd4",
  null
  
)

export default component.exports